import type {OmitStrict} from 'type-zoo'
import type {TMinorActionPromptDataDebtCollectorBirthday} from '@kapitalist/contract/types'
import {show$} from '@kapitalist/contract/utils/millions/copy'
import {MillionsMath} from '@kapitalist/contract/utils/millions/math'
import {skins} from '~/game/skins'
import {PlayerGamePosition} from '~/models/game/GamePosition'
import type {
  TMinorActionPromptUserFacingDescriptionData,
  TMinorActionPromptValidResponseData,
} from '~/models/game/MinorActionPrompt'
import MinorActionPromptPaySomething from '~/models/game/MinorActionPrompts/MinorActionPromptPaySomething'
import MinorActionPayOther from '~/models/game/MinorActions/MinorActionPayOther'
import type {AnyMinorAction} from '~/models/game/types'
import {sentenceCase, xVerbY} from '~/utils/language'

type PublicMembersFromApi = OmitStrict<
  TMinorActionPromptDataDebtCollectorBirthday,
  'type'
>

// Paying off a Debt Collector or Birthday
export default class MinorActionPromptPayOther
  extends MinorActionPromptPaySomething<TMinorActionPromptDataDebtCollectorBirthday>
  implements PublicMembersFromApi
{
  protected _validResponses(
    data: TMinorActionPromptValidResponseData
  ): AnyMinorAction | AnyMinorAction[] {
    return this.withJustSayNo(
      data,
      new MinorActionPayOther({
        ...this.datasource,
        paidWith: [], // this will be filled in later once the user chooses how to pay
      })
    )
  }

  public userFacingDescription(
    data: TMinorActionPromptUserFacingDescriptionData
  ): string {
    const {gamePosition, tense, skin} = data
    const currentPlayer =
      gamePosition instanceof PlayerGamePosition
        ? gamePosition.currentPlayer
        : undefined
    const {majorActor, minorActor} = this

    const {conjugatedVerb, xNoun, yNoun} = xVerbY(
      tense,
      minorActor,
      'pay',
      majorActor,
      currentPlayer?.id
    )

    return skins[skin].gameLogDescriptions.minorActionPrompts.payPrompt({
      tense,
      actor: xNoun === minorActor.username ? xNoun : sentenceCase(xNoun),
      verb: conjugatedVerb,
      targetName: yNoun,
      amount: show$(
        MillionsMath.min(minorActor.portfolio.totalValue(), this.millionsOwed)
      ),
    })
  }
}
